
// Usaremos iconos de lucide-react (disponibles en el entorno) para elementos que no tienen imágenes.
//import { BookOpen, MapPin, Layers, Briefcase, FileText, Compass } from 'lucide-react'; 
//import LandingSection from '../../components/Preguntas.jsx';
//import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion';


import React, { useState, useMemo, forwardRef, useEffect } from 'react';
import { 
  Search, BookOpen, Scale, 
  ShieldCheck, AlertTriangle, ChevronDown, 
  Leaf, Info, Map, FileText, Globe,
  Compass, MapPin, Layers, Briefcase,CheckCircle2
} from 'lucide-react';
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion';
import GemmaAssistant from './GemmaAssistant';

// Las rutas de imágenes y datos de regiones se mantienen
const carouselImages = [
  "/images/Sierra_del_tigre.jpeg",
  "/images/SierraOccidental.jpeg",
  "/images/Foto-Chapala.jpeg",
  "/images/Foto-Costa.jpeg",
  "/images/Foto-Tapalpa.jpg",
];

// Lista de 12 regiones con municipios (usando los datos originales)
const regiones = [
  { id: "costalegre", nombre: "Costalegre", municipios: ["Cabo Corrientes", "Cihuatlán", "La Huerta", "Tomatlán"], img: "/images/Foto-Costa.jpg", status: "Vigente" },
  { id: "chapala", nombre: "Chapala", municipios: ["Chapala", "Jamay", "Jocotepec", "Poncitlán", "Ocotlán", "Tizapán el Alto", "Tuxcueca"], img: "/images/chapala-banner.jpg", status: "Vigente" },
  { id: "tapalpa", nombre: "Tapalpa", municipios: ["Atemajac de Brizuela", "Chiquilistlán", "San Gabriel", "Tapalpa"], img: "/images/foto-tapalpa.jpg", status: "Vigente" },
  { id: "rioverde", nombre: "Río Verde", municipios: ["Acatic", "Cañadas de Obregón", "Cuquío","Jalostotitlán","Mexticacán","San Julián","San Miguel el Alto","Tepatitlán de Morelos","Valle de Guadalupe","Yahualica de González Gallo"], img: "/images/Plaza_Principal_Mexticacan.jpg", status: "Vigente" },
  { id: "altosnorte", nombre: "Altos Norte", municipios: ["Encarnación de Díaz", "Lagos de Moreno", "Ojuelos de Jalisco","Cuquío","San Diego de Alejandría", "San Juan de los Lagos", "Teocaltiche", "Unión de San Antonio", "Villa Hidalgo"], img: "/images/altosnorte2.jpg", status: "Vigente" },
  { id: "PaisajeAgavero", nombre: "Paisaje Agavero", municipios: ["Amatitán", "El Arenal", "Magdalena", "Tequila", "Teuchitlán"], img: "/images/Foto-paisaje agavero.jpg", status: "Vigente" },
  { id: "lagunas", nombre: "Lagunas", municipios: ["Acatlán de Juárez", "Amacueca", "Atoyac","Techaluta de Montenegro","Teocuitatlán de Corona","Villa Corona","Zacoalco de Torres","Sayula"], img: "/images/Lagunas.jpeg", status: "En Proceso de Publicación" },
  { id: "sierraoccidental", nombre: "Sierra Occidental", municipios: ["Atenquillo", "Guachinango", "Mascota", "Mixtlán", "San Sebastián del Oeste", "Talpa de Allende"], img: "/images/SierraOcciental2.png", status: "Vigente" },
  { id: "cacs", nombre: "Cuenca Alta de la Costa Sur", municipios: ["Casimiro Castillo", "Cuautitlán de García Barragán", "Villa Purificación"], img: "/images/CONANP2.jpeg", status: "Vigente" },
  { id: "riozula", nombre: "Río Zula", municipios: ["Arandas", "Atotonilco", "Ayotlán","Degollado","Jesús María","La Barca","San Ignacio CG","Tototlán","Zapotlán del Rey"], img: "/images/zula.jpeg", status: "Vigente" },
   { id: "sierradelTigre", nombre: "Sierra del Tigre", municipios: ["Valle de Juárez", "Tamazula de Gordiano", "Mazamitla","La Manzanilla","Concepción de Buenos Aires","Quitupan","Zacoalco de Torres","Sayula"], img: "/images/Sierra_del_Tigre.jpeg", status: "Suspendido" },
   { id: "jira", nombre: "Región Cuenca Baja del Río Ayuquila(JIRA)", municipios: ["Autlán de Navarro", "Ejutla", "El Grullo", "El Limón", "Tonaya", "Tolimán", "Tuxcacuesco", "Unión de Tula", "Zapotitlán de Vadillo"], img: "images/Jira/bannerJira.jpeg", status: "Suspendido" },
];

const CATEGORIES = {
  "Bitácoras Ambientales": {
    icon: BookOpen,
    color: "border-l-[#1b3d2f] dark:border-l-emerald-500",
    bg: "bg-[#1b3d2f]/5 dark:bg-emerald-500/10",
    text: "text-[#1b3d2f] dark:text-emerald-400"
  },
  "Programa de Ordenamiento": {
    icon: Map,
    color: "border-l-[#a6894a] dark:border-l-amber-500",
    bg: "bg-[#a6894a]/5 dark:bg-amber-500/10",
    text: "text-[#a6894a] dark:text-amber-400"
  },
  "Aspectos Jurídicos": {
    icon: Scale,
    color: "border-l-slate-700 dark:border-l-slate-400",
    bg: "bg-slate-100 dark:bg-slate-700/50",
    text: "text-slate-700 dark:text-slate-300"
  },
  "Derechos y Propiedad": {
    icon: ShieldCheck,
    color: "border-l-emerald-600 dark:border-l-emerald-400",
    bg: "bg-emerald-50 dark:bg-emerald-900/20",
    text: "text-emerald-700 dark:text-emerald-300"
  },
  "Denuncias y Conflictos": {
    icon: AlertTriangle,
    color: "border-l-red-600 dark:border-l-red-500",
    bg: "bg-red-50 dark:bg-red-900/20",
    text: "text-red-700 dark:text-red-400"
  }
};

// const FAQS_DATA = [
//   { id: 1, category: "Bitácoras Ambientales", question: "¿Qué son las Bitácoras Ambientales?", answer: 
//     (
//       <div className="space-y-3">
//         <p>Son un <strong>mecanismo público de transparencia</strong> que documenta de manera cronológica las fases, actividades y procesos del ordenamiento ecológico en Jalisco.</p>
//         <p>Funcionan principalmente como:</p>
//         <ul className="list-disc pl-5 space-y-1">
//           <li>Espacio de consulta ciudadana.</li>
//           <li>Herramienta de seguimiento a la planeación territorial.</li>
//           <li>Repositorio de actualización de instrumentos vigentes.</li>
//         </ul>
//       </div>
//     )
//     },
//   { id: 2, category: "Bitácoras Ambientales", question: "¿Qué puedo consultar en ellas?", answer: "Información técnica y documental: modelos de ordenamiento, anexos digitales, cartografía vectorial/raster e insumos oficiales asociados al proceso." },
//   { id: 3, category: "Bitácoras Ambientales", question: "¿Quién puede consultar y usar las bitácoras ambientales?", answer: "La plataforma está disponible para toda la ciudadanía. Está diseñada para facilitar el acceso a información ambiental y territorial de interés público, siendo de especial utilidad para personas propietarias, sectores productivos, consultores, académicos y autoridades que requieren datos para el análisis, la toma de decisiones informadas y la investigación." },
//   { id: 4, category: "Programa de Ordenamiento", question: "¿Qué es un ordenamiento ecológico?", answer: "Es un proceso de planeación que establece reglas y lugares específicos para las actividades humanas, buscando proteger el medio ambiente y aprovechar los recursos naturales de forma responsable." },
//   { id: 5, category: "Programa de Ordenamiento", question: "¿Para qué sirve el programa de ordenamiento ecológico?", answer: "Es como el plan maestro de nuestro territorio. Sirve para poner orden y evitar que las actividades humanas destruyan la naturaleza de la que dependemos. Sus beneficios principales son:"+

// "Claridad para todos: Si alguien quiere invertir o construir, sabe exactamente qué reglas debe seguir desde el principio de certeza jurídica."+
// "Evitar pleitos: Previene conflictos entre vecinos o sectores (por ejemplo, evita que se ponga una fábrica contaminante junto a una zona de cultivo de alimentos)."+

// "Protección del futuro: Asegura que sigamos teniendo agua, suelos fértiles y aire limpio al definir dónde no se debe urbanizar."+

// "Trabajo en equipo: Logra que el municipio, el estado y la federación se pongan de acuerdo y no den permisos contradictorios." },
//   { id: 6, category: "Aspectos Jurídicos", question: "¿Cuáles son los fundamentos jurídicos del Programa de Ordenamiento Ecológico?", answer: "El Ordenamiento Ecológico no es una ocurrencia; es una obligación legal que nace desde nuestra Constitución y se organiza de la siguiente manera:"+

// "La Constitución Mexicana (Nivel Máximo): El Artículo 4° dice que todos tenemos derecho a un medio ambiente sano, y el Artículo 27 establece que el Estado puede regular el uso de los recursos naturales para beneficio social."+

// "LGEEPA (Ley General): La Ley General del Equilibrio Ecológico y la Protección al Ambiente es la que explica 'el cómo' se debe hacer el ordenamiento en todo el país."+

// "Su Reglamento: Detalla los pasos técnicos y los tiempos que el gobierno debe seguir para que el proceso sea legal y transparente."+

// "LEEEPA (Ley Estatal): Tiene su propia ley para adaptar estas reglas a sus problemas específicos de suelo y clima." },
// { id: 7, category: "Aspectos Jurídicos", question: "¿Cuándo adquiere validez jurídica el programa de Ordenamiento Ecológico?", answer: "Para que el programa sea \"ley\" y todos debían obedecerlo, debe cumplir con dos pasos finales:"+

// "La Publicación: Debe aparecer oficialmente en el Periódico Oficial \"El Estado de Jalisco\" (para planes regionales) o en la Gaceta Municipal (para planes locales). Si no está publicado ahí, no se puede aplicar ninguna sanción ni restricción y es válido a partir del día siguiente de su publicación oficial."+

// "La Inscripción: También debe inscribirse en el Registro Público de la Propiedad. Esto es vital porque así, cuando alguien consulte los datos de un terreno, aparecerá que ese predio está sujeto a las reglas del Ordenamiento Ecológico. A partir de ese momento, ninguna autoridad puede dar un permiso de construcción o cambio de uso de suelo que vaya en contra de lo que dice el programa." },

//   { id: 8, category: "Derechos y Propiedad", question: "¿El Programa de Ordenamiento Ecológico afecta mis derechos de propiedad o el uso actual de mi predio?", answer: "No. El programa respeta lo que ya existe, pero pone reglas para el futuro. Aquí te explicamos los tres puntos clave:"+

// "Tu propiedad: es tuya. El programa no cambia quién es el dueño de la tierra. Si tu terreno es propiedad privada, ejidal o comunal, así seguirá siendo."+

// "Respeto al uso actual (Derechos adquiridos): Si hoy tienes una huerta o una casa, el programa reconoce ese uso. No te van a pedir que quites lo que ya tienes. Sin embargo, si en el futuro quieres cambiar o ampliar lo que haces (por ejemplo, convertir un bosque en una fábrica), ahí sí deberás consultar las nuevas reglas."+
// "Orientaciones para mejorar: Lo que el programa hace es darte \"instrucciones de buen uso\"."  },
// { id: 9, category: "Derechos y Propiedad", question: "¿Qué sucede cuando existen controversias entre los usos de suelo establecidos en los distintos programas de ordenamiento ecológico y urbano?", answer: " A veces, un plan dice que en un terreno se pueden hacer casas (urbano) y otro dice que es zona de conservación (ecológico). Cuando esto sucede, se resuelve bajo tres reglas:"+

// "El principio de \"Mayor Protección\": Por ley, siempre debe ganar la regla que proteja mejor el medio ambiente y la salud de las personas. Si el plan ecológico dice que ahí nace agua, aunque el plan urbano diga \"casas\", se debe respetar la protección del agua."+

// "La actualización más reciente: Prevalece el estudio más reciente, porque refleja la realidad actual del terreno."+

// "Coordinación obligatoria: Las autoridades de desarrollo urbano y las de medio ambiente están obligadas a sentarse y unificar sus criterios para que el ciudadano no reciba mensajes contradictorios. "},
// { id: 10, category: "Derechos y Propiedad", question: "El portal dice que mi terreno está en una zona de \"Protección\", ¿significa que ya no vale nada?", answer: "Al contrario. Una zona de Protección o Preservación significa que tu terreno tiene un valor ambiental único (como un bosque o un manantial)."+
// "Aunque no puedas construir un centro comercial, el valor de estos terrenos está en los Servicios Ambientales."+
// "El Gobierno de Jalisco y SEMADET cuentan con programas de Pago por Servicios Ambientales o incentivos fiscales para dueños que conservan estas áreas. Tu terreno sigue teniendo valor, pero un valor enfocado en la vida y el futuro de la región."},

//   { id: 11, category: "Denuncias y Conflictos", question: "¿Qué puedo hacer si observo una actividad que no respeta el Ordenamiento Ecológico?", answer: "Qué hacer si ves tala de árboles, construcciones sin permiso o actividades prohibidas según el Ordenamiento Ecologíco de tu región. Puedes denunciar y seguir los siguientes pasos:"+
// "1-Revisa el lugar"+  
// "Consulta la Bitácora del ordenamiento ecologico aplicable, para saber qué está permitido y que no."+
// "2-Toma evidencia"+
// "Fotos, videos y identificar la ubicación exacta del sitio."+
// "3-Denuncia:"+
// "*PROFEPA: daños a bosques, selvas, ríos, costas o fauna silvestre."+
// "*PROEPA Jalisco: contaminación, tiraderos clandestino, humo o daños ambientales."+
// "*Ayuntamiento Municipal: construcciones sin permiso, mal uso del suelo o ruido."+
// "La denuncia puede ser anónima y el ordenamiento ecológico ayuda a comprobar que la actividad es ilegal."}
// ];
const FAQS_DATA = [
  { 
    id: 1, 
    category: "Bitácoras Ambientales", 
    question: "¿Qué son las Bitácoras Ambientales?", 
    answer: (
      <div className="space-y-3">
        <p>Son un <strong>mecanismo público de transparencia</strong> que documenta, de manera cronológica, las fases, actividades y procesos relacionados con el ordenamiento ecológico y territorial en Jalisco.</p>
        <p>Funcionan principalmente como:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Espacio de <strong>consulta pública</strong>.</li>
          <li>Herramienta para dar seguimiento a la planeación.</li>
          <li>Repositorio de actualización de instrumentos vigentes.</li>
        </ul>
      </div>
    )
  },
  { 
    id: 2, 
    category: "Bitácoras Ambientales", 
    question: "¿Qué puedo consultar en las Bitácoras Ambientales?", 
    answer: (
      <div className="space-y-3">
        <p>Toda la <strong>información técnica y documental</strong> que conforma el Modelo de Ordenamiento Ecológico:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Documentos y anexos en formatos digitales.</li>
          <li><strong>Información cartográfica</strong> (formatos vectoriales y raster).</li>
          <li>Insumos oficiales asociados al proceso de ordenamiento.</li>
        </ul>
      </div>
    )
  },
  { 
    id: 3, 
    category: "Bitácoras Ambientales", 
    question: "¿Quién puede consultar y usar las bitácoras ambientales?", 
    answer: (
      <div className="space-y-3">
        <p>La plataforma está <strong>disponible para toda la ciudadanía</strong>. Está diseñada para facilitar el acceso a información ambiental y territorial de interés público.</p>
        <p>Es de especial utilidad para:</p>
        <div className="grid grid-cols-2 gap-2 text-xs font-semibold text-slate-500 uppercase tracking-wider">
          <div className="bg-slate-50 p-2 rounded">Propietarios</div>
          <div className="bg-slate-50 p-2 rounded">Sectores Productivos</div>
          <div className="bg-slate-50 p-2 rounded">Consultores</div>
          <div className="bg-slate-50 p-2 rounded">Académicos</div>
          <div className="bg-slate-50 p-2 rounded">Autoridades</div>
        </div>
      </div>
    )
  },
  { 
    id: 4, 
    category: "Bitácoras Ambientales", 
    question: "¿Para qué me sirven usar las Bitácoras Ambientales?", 
    answer: (
      <div className="space-y-3">
        <p>Sirven para consultar información ambiental y territorial de manera <strong>clara y accesible</strong>.</p>
        <p>Es el paso previo ideal antes de:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Planear un proyecto.</li>
          <li>Realizar un trámite oficial.</li>
          <li>Hacer consultas sobre el <strong>uso del suelo en Jalisco</strong>.</li>
        </ul>
      </div>
    )
  },
  { 
    id: 5, 
    category: "Programa de Ordenamiento", 
    question: "¿Qué es un ordenamiento ecológico?", 
    answer: (
      <div className="space-y-3">
        <p>Es un <strong>proceso de planeación</strong> que establece reglas y lugares específicos para las actividades humanas.</p>
        <p>Busca un equilibrio: <strong>proteger el medio ambiente</strong> mientras se aprovechan los recursos naturales de forma responsable.</p>
      </div>
    )
  },
  { 
    id: 6, 
    category: "Programa de Ordenamiento", 
    question: "¿Para qué sirve el programa de ordenamiento ecológico?", 
    answer: (
      <div className="space-y-4">
        <p>Es el <strong>"plan maestro"</strong> de nuestro territorio para evitar que las actividades humanas destruyan la naturaleza.</p>
        <div className="space-y-3">
          <div className="flex gap-3">
            <div className="mt-1 bg-emerald-100 p-1 rounded-full"><CheckCircle2 size={14} className="text-emerald-700"/></div>
            <p><strong>Claridad para todos:</strong> Certeza jurídica para inversores y constructores sobre las reglas a seguir.</p>
          </div>
          <div className="flex gap-3">
            <div className="mt-1 bg-emerald-100 p-1 rounded-full"><CheckCircle2 size={14} className="text-emerald-700"/></div>
            <p><strong>Evitar pleitos:</strong> Previene conflictos entre sectores (ej. evitar fábricas junto a zonas agrícolas).</p>
          </div>
          <div className="flex gap-3">
            <div className="mt-1 bg-emerald-100 p-1 rounded-full"><CheckCircle2 size={14} className="text-emerald-700"/></div>
            <p><strong>Protección del futuro:</strong> Asegura agua, suelos fértiles y aire limpio al definir zonas no urbanizables.</p>
          </div>
          <div className="flex gap-3">
            <div className="mt-1 bg-emerald-100 p-1 rounded-full"><CheckCircle2 size={14} className="text-emerald-700"/></div>
            <p><strong>Trabajo en equipo:</strong> Coordinación entre municipio, estado y federación para evitar permisos contradictorios.</p>
          </div>
        </div>
      </div>
    )
  },
  { 
    id: 7, 
    category: "Aspectos Jurídicos", 
    question: "¿Cuáles son los fundamentos jurídicos del Programa de Ordenamiento Ecológico?", 
    answer: (
      <div className="space-y-4">
        <p>No es una ocurrencia; es una <strong>obligación legal</strong> organizada jerárquicamente:</p>
        <div className="border-l-4 border-slate-200 pl-4 space-y-3">
          <p><strong>Constitución Mexicana:</strong> Art. 4° (Derecho a medio ambiente sano) y Art. 27 (Regulación de recursos naturales).</p>
          <p><strong>LGEEPA (Ley General):</strong> Explica el "cómo" se debe hacer el ordenamiento en todo el país.</p>
          <p><strong>Reglamento de LGEEPA:</strong> Detalla los pasos técnicos y tiempos legales.</p>
          <p><strong>LEEEPA (Ley Estatal):</strong> Adapta las reglas a los problemas específicos de Jalisco.</p>
        </div>
      </div>
    )
  },
  { 
    id: 8, 
    category: "Aspectos Jurídicos", 
    question: "¿Cuándo adquiere validez jurídica el programa de Ordenamiento Ecológico?", 
    answer: (
      <div className="space-y-4">
        <p>Para que sea "ley" y de cumplimiento obligatorio, requiere dos pasos:</p>
        <div className="bg-slate-50 p-4 rounded-xl space-y-4">
          <div>
            <span className="text-[10px] font-black bg-slate-200 px-2 py-0.5 rounded text-slate-600 uppercase mb-1 inline-block">Paso 1</span>
            <p><strong>Publicación:</strong> En el Periódico Oficial "El Estado de Jalisco" (regionales) o Gaceta Municipal (locales).</p>
          </div>
          <div>
            <span className="text-[10px] font-black bg-slate-200 px-2 py-0.5 rounded text-slate-600 uppercase mb-1 inline-block">Paso 2</span>
            <p><strong>Inscripción:</strong> En el Registro Público de la Propiedad. Esto asegura que la limitación aparezca al consultar un predio.</p>
          </div>
        </div>
        <p className="text-xs italic text-slate-500">Es válido a partir del día siguiente de su publicación oficial.</p>
      </div>
    )
  },
  { 
    id: 9, 
    category: "Derechos y Propiedad", 
    question: "¿El Programa de Ordenamiento Ecológico afecta mis derechos de propiedad o el uso actual de mi predio?", 
    answer: (
      <div className="space-y-4">
        <p className="font-semibold text-slate-800 underline decoration-emerald-500 decoration-2 underline-offset-4">No. El programa respeta lo existente bajo tres puntos clave:</p>
        <ul className="space-y-3">
          <li><strong>1. Tu propiedad es tuya:</strong> No cambia quién es el dueño. La tierra sigue siendo privada, ejidal o comunal.</li>
          <li><strong>2. Derechos adquiridos:</strong> Si hoy tienes una huerta o casa, el programa reconoce ese uso. No se te pedirá quitar lo que ya tienes.</li>
          <li><strong>3. Orientaciones futuras:</strong> Solo aplica si decides cambiar o ampliar lo que haces hoy (ej. convertir bosque en fábrica).</li>
        </ul>
      </div>
    )
  },
  { 
    id: 10, 
    category: "Denuncias y Conflictos", 
    question: "¿Qué sucede cuando existen controversias entre los usos de suelo establecidos en distintos programas?", 
    answer: (
      <div className="space-y-4">
        <p>Si un plan dice "urbano" y otro "ecológico", se resuelve bajo tres reglas:</p>
        <ol className="list-decimal pl-5 space-y-3">
          <li><strong>Principio de "Mayor Protección":</strong> Siempre gana la regla que proteja mejor el medio ambiente y la salud humana.</li>
          <li><strong>Actualización más reciente:</strong> Prevalece el estudio más nuevo por reflejar la realidad actual del terreno.</li>
          <li><strong>Coordinación obligatoria:</strong> Las autoridades deben unificar criterios para no dar mensajes contradictorios al ciudadano.</li>
        </ol>
      </div>
    )
  },
  { 
    id: 11, 
    category: "Programa de Ordenamiento", 
    question: "¿El Programa de Ordenamiento Ecológico puede modificarse una vez publicado?", 
    answer: (
      <div className="space-y-4">
        <p>Sí, no es permanente. Se actualiza según los plazos de la LEEEPA:</p>
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-amber-50 p-3 rounded-lg border border-amber-100">
            <p className="text-[10px] font-bold text-amber-800 uppercase">Regionales</p>
            <p className="text-xl font-black text-amber-900">Cada 6 años</p>
          </div>
          <div className="bg-emerald-50 p-3 rounded-lg border border-emerald-100">
            <p className="text-[10px] font-bold text-emerald-800 uppercase">Locales</p>
            <p className="text-xl font-black text-emerald-900">Cada 3 años</p>
          </div>
        </div>
        <p className="text-sm text-slate-500">Cualquier cambio requiere el mismo rigor científico y consulta pública que el original.</p>
      </div>
    )
  },
  { 
    id: 12, 
    category: "Derechos y Propiedad", 
    question: "El portal dice que mi terreno está en zona de 'Protección', ¿ya no vale nada?", 
    answer: (
      <div className="space-y-3">
        <p className="text-lg font-bold text-emerald-800">Al contrario.</p>
        <p>Significa que tu terreno tiene un <strong>valor ambiental único</strong> (como un bosque o manantial).</p>
        <p>El valor está en los <strong>Servicios Ambientales</strong>. El Gobierno de Jalisco cuenta con programas de Pago por Servicios Ambientales o incentivos fiscales para dueños que conservan estas áreas vitales para el futuro.</p>
      </div>
    )
  },
  { 
    id: 13, 
    category: "Denuncias y Conflictos", 
    question: "¿Qué puedo hacer si observo una actividad que no respeta el Ordenamiento Ecológico?", 
    answer: (
      <div className="space-y-4">
        <p>Sigue estos tres pasos si detectas tala, construcciones sin permiso o actividades prohibidas:</p>
        <div className="space-y-4">
          <div className="flex gap-4 items-start">
            <span className="w-8 h-8 rounded-full bg-[#1b3d2f] text-white flex items-center justify-center shrink-0 font-bold">1</span>
            <div>
              <p className="font-bold">Revisa el lugar</p>
              <p className="text-sm">Consulta la Bitácora para saber qué está permitido y qué no en esa región.</p>
            </div>
          </div>
          <div className="flex gap-4 items-start">
            <span className="w-8 h-8 rounded-full bg-[#1b3d2f] text-white flex items-center justify-center shrink-0 font-bold">2</span>
            <div>
              <p className="font-bold">Toma evidencia</p>
              <p className="text-sm">Fotos, videos e identifica la ubicación exacta del sitio.</p>
            </div>
          </div>
          <div className="flex gap-4 items-start">
            <span className="w-8 h-8 rounded-full bg-red-600 text-white flex items-center justify-center shrink-0 font-bold">3</span>
            <div className="flex-1 bg-red-50 p-3 rounded-xl">
              <p className="font-bold text-red-900 mb-2 uppercase text-xs">Instancias de denuncia:</p>
              <ul className="text-xs space-y-1 text-red-800">
                <li>• <strong>PROFEPA:</strong> Bosques, selvas, ríos, costas o fauna.</li>
                <li>• <strong>PROEPA Jalisco:</strong> Contaminación, humo, tiraderos.</li>
                <li>• <strong>Ayuntamiento:</strong> Construcciones sin permiso o ruido.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
];
/**
 * Componente Carousel animado y moderno.
 */
function Carousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setIndex((prev) => (prev + 1) % carouselImages.length),
      5000
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full h-[85vh] overflow-hidden shadow-2xl shadow-indigo-900/50">
      {carouselImages.map((img, i) => (
        <img
          key={i}
          src={img}
          alt={`Slide ${i}`}
          // Aplicamos la opacidad y la transición de forma nativa CSS
          style={{ 
            opacity: i === index ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
          }}
          className="absolute w-full h-full object-cover transform scale-105"
          // Fallback en caso de que la URL de la imagen no funcione
          onError={(e) => {
            e.target.onerror = null; 
            e.target.src = "https://placehold.co/1920x1080/1e293b/ffffff?text=Ordenamiento+Territorial";
          }}
        />
      ))}
      {/* Overlay degradado para un contraste premium */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/30 flex flex-col items-center justify-center text-center px-6">
        <h1 className="text-5xl md:text-8xl font-black text-white tracking-tight drop-shadow-xl animate-scale-up-and-fade">
          Ordenamientos Territoriales
        </h1>
        <p className="text-xl md:text-3xl font-extralight text-sky-200 mt-6 max-w-4xl drop-shadow-lg animate-fade-in-up-delay">
          Consulta y explora la información ambiental y urbana de las <span className="font-semibold text-cyan-300">regiones de Jalisco</span>
        </p>
        <a href="#regiones" className="mt-12 px-10 py-4 bg-gradient-to-r from-sky-500 to-cyan-500 text-white text-xl font-bold rounded-full shadow-2xl shadow-cyan-500/50 hover:from-sky-600 hover:to-cyan-600 transition transform hover:scale-105 duration-300 ease-in-out border-2 border-white/50">
            Explora las Bitácoras ambientales de Jalisco <Compass className="inline-block w-6 h-6 ml-3" />
        </a>
      </div>
    </div>
  );
}

const FAQAccordion = forwardRef(({ faq, isOpen, onToggle }, ref) => {
  const config = CATEGORIES[faq.category] || CATEGORIES["Bitácoras Ambientales"];
  const IconComponent = config.icon;

  return (
    <motion.div 
      ref={ref}
      layout
      className={`group mb-4 border border-slate-200 bg-white rounded-2xl overflow-hidden transition-all border-l-8 ${config.color} ${isOpen ? 'shadow-xl ring-1 ring-slate-100' : 'hover:shadow-md'}`}
    >
      <button onClick={onToggle} className="w-full flex items-center justify-between p-6 text-left outline-none">
        <div className="flex items-center gap-5 flex-1">
          <div className={`p-3 rounded-xl shrink-0 ${config.bg} ${config.text}`}>
            <IconComponent size={24} />
          </div>
          <div>
            <span className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 block mb-1">{faq.category}</span>
            <span className={`text-base md:text-lg font-bold leading-tight ${isOpen ? 'text-[#1b3d2f]' : 'text-slate-700 group-hover:text-emerald-800'}`}>
              {faq.question}
            </span>
          </div>
        </div>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }} className="ml-4 shrink-0 bg-slate-50 p-2 rounded-full">
          <ChevronDown size={20} className="text-slate-400" />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
          >
            <div className="px-6 md:px-20 pb-8 text-slate-600 text-sm md:text-base leading-relaxed border-t border-slate-50 pt-6 bg-white">
              {faq.answer}
              <div className="mt-8 flex flex-wrap gap-4 border-t border-slate-50 pt-6">
                {/* <button className="text-[10px] font-black text-[#a6894a] flex items-center gap-2 hover:scale-105 transition-transform uppercase tracking-widest">
                  <FileText size={14} /> Descargar PDF
                </button>
                <button className="text-[10px] font-black text-emerald-700 flex items-center gap-2 hover:scale-105 transition-transform uppercase tracking-widest">
                  <MapPin size={14} /> Ver en Mapa
                </button> */}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
});

/**
 * Componente principal (Home) renombrado a App para el entorno de un solo archivo.
 */
export default function App() {

 const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('Todas');
  const [openId, setOpenId] = useState(null);

  const filteredFaqs = useMemo(() => {
    return FAQS_DATA.filter(f => {
      const matchesSearch = f.question.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCat = activeCategory === 'Todas' || f.category === activeCategory;
      return matchesSearch && matchesCat;
    });
  }, [searchTerm, activeCategory]);
  return (
    // Fondo de degradado sutil para toda la página
    <div className="min-h-screen font-sans bg-gradient-to-br from-gray-50 to-gray-200">
      <Carousel />
      
      {/* Sección de Recursos - Diseño de Tarjetas con Gradiente Animado */}
      <div className="max-w-7xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-black text-center text-gray-800 tracking-tight mb-16">
          Recursos Informativos
        </h2>
        <div className="grid gap-10 md:grid-cols-3">
          {/* Botón 1: Opinión Técnica */}
        <a
            href="/fichas"
            className="group flex flex-col items-center p-10 rounded-3xl shadow-2xl bg-white border-b-4 border-indigo-400 hover:border-indigo-600 transition duration-300 transform hover:-translate-y-1 cursor-pointer"
          >
            <img src="/images/fichas_informativas.png" alt="Manual PyPDU" className="w-16 h-16 mb-4" />
            {/* <BookOpen className="text-6xl mb-6 text-indigo-600 transition group-hover:text-indigo-800" /> */}
            <h3 className="text-2xl font-extrabold text-gray-900 group-hover:text-indigo-700 transition">Fichas Informativas</h3>
            <p className="text-base mt-3 text-center text-gray-500">
              Guía de consulta para conocer la compatibilidad de actividades y los usos de suelo. 
            </p>
          </a>

          {/* Botón 2: Manual PyPDU */}
          <a
            href="https://siga.jalisco.gob.mx/ordenamiento/archivos/INFOGRAFIA_OPINION_TECNICA_2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            // Tarjeta con gradiente y efecto de pop al hacer hover
            className="group flex flex-col items-center p-10 rounded-3xl shadow-2xl bg-white border-b-4 border-sky-400 hover:border-sky-600 transition duration-300 transform hover:-translate-y-1 cursor-pointer"
          >
            {/* <Layers className="text-6xl mb-6 text-sky-600 transition group-hover:text-sky-800" /> */}
            <img src="/images/OPINION_TECNICA.png" alt="Opinión Técnica" className="w-16 h-16 mb-4" />
            <h3 className="text-2xl font-extrabold text-gray-900 group-hover:text-sky-700 transition">Opinión Técnica</h3>
            <p className="text-base mt-3 text-center text-gray-500">
              Evaluación de proyectos con enfoque territorial.
            </p>
          </a>
          
          {/* Botón 3: Fichas Informativas */}
          <a
            href="https://siga.jalisco.gob.mx/ordenamiento/archivos/EtapasPDU/Manual_para_promover_PyPDU.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center p-10 rounded-3xl shadow-2xl bg-white border-b-4 border-green-400 hover:border-green-600 transition duration-300 transform hover:-translate-y-1 cursor-pointer"
          >
             <img src="/images/1_1.png" alt="Manual PyPDU" className="w-16 h-16 mb-4" />
            {/* <FileText className="text-6xl mb-6 text-green-600 transition group-hover:text-green-800" /> */}
            <h3 className="text-2xl font-extrabold text-gray-900 group-hover:text-green-700 transition">Manual para PyPDU</h3>
            <p className="text-base mt-3 text-center text-gray-500">
              6 ETAPAS para la elaboración y actualización de Planes y Programas de Desarrollo Urbano.
            </p>
          </a>

            
        </div>
      </div>

      {/* Sección de Regiones - Tarjetas con Efecto Luminoso al Hover */}
      <section id="regiones" className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="text-4xl font-black text-center text-gray-800 tracking-tight mb-16">
          Explora las Bitácoras ambientales de Jalisco
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {regiones.map((r, index) => (
            // Tarjeta con efecto de elevación y borde luminoso al hover
            <a
              key={r.id}
              href={`/${r.id}`}
              style={{ animationDelay: `${index * 0.1}s` }} 
              className="group relative bg-white/80 backdrop-blur-md shadow-xl rounded-3xl overflow-hidden transition-all duration-500 transform hover:-translate-y-1 hover:shadow-2xl hover:shadow-cyan-400/50 animate-fade-in-up"
            >
              <div className="relative">
                <img 
                  src={r.img} 
                  alt={r.nombre} 
                  className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-105" 
                  // Fallback: Si la imagen no carga, usamos un placeholder.
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = "https://placehold.co/800x400/374151/ffffff?text=Regi%C3%B3n+de+Jalisco";
                  }}
                />
                {/* Degradado para mejorar la legibilidad del badge */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className={`absolute top-4 right-4 px-4 py-1 text-xs font-black uppercase rounded-full shadow-lg 
                  ${r.status === "Vigente" ? 'bg-green-600 text-white' : 
                   r.status === "En Proceso de Publicación" ? 'bg-yellow-500 text-gray-900' :
                   'bg-gray-600 text-white'}`}
                >
                  {r.status}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-3xl font-extrabold mb-2 text-gray-900 group-hover:text-cyan-600 transition">{r.nombre}</h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  <span className="font-semibold text-gray-700">Municipios:</span> {r.municipios.join(", ")}
                </p>
                <div className="pt-2">
                  <span
                    className="inline-block px-8 py-3 bg-gradient-to-r from-sky-600 to-cyan-600 text-white font-bold rounded-full shadow-lg transition transform group-hover:from-sky-700 group-hover:to-cyan-700 group-hover:scale-[1.02]"
                  >
                    Ver Detalle Regional
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>


      {/* SECCIÓN FINAL: BITÁCORA AMBIENTAL (Integrada como cierre) */}
      <section className="bg-white py-24 mt-20 border-t border-slate-100">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 font-black uppercase text-[10px] tracking-[0.3em] mb-2 block">Bitácoras Ambientales</span>
            <h2 className="text-4xl font-black uppercase tracking-tighter text-slate-900">Preguntas Frecuentes</h2>
            <p className="text-slate-500 mt-4 text-sm max-w-xl mx-auto">Resuelve tus dudas sobre el seguimiento, planeación y consulta de los instrumentos de ordenamiento en Jalisco.</p>
          </div>

          {/* Buscador Ajustado */}
          <div className="mb-8">
            <div className="relative group">
              <Search className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300 group-focus-within:text-emerald-500 transition-colors" size={20} />
              <input 
                type="text" 
                placeholder="Busca términos como 'fundamentos', 'controversias' o 'validez'..." 
                className="w-full pl-14 pr-6 py-5 bg-slate-50 border border-slate-200 rounded-2xl outline-none focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500 text-slate-700 transition-all shadow-inner text-base"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* Botones de Categoría con Scroll Lateral y Ajuste Completo */}
          <div className="mb-10">
            <div className="flex flex-wrap md:flex-nowrap md:overflow-x-auto gap-2 pb-4 no-scrollbar">
              {['Todas', ...Object.keys(CATEGORIES)].map(cat => (
                <button 
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                   className={`px-5 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-wider whitespace-nowrap transition-all border shrink-0 ${
                    activeCategory === cat 
                    ? 'bg-emerald-600 text-white border-emerald-600 shadow-lg shadow-emerald-500/40 ring-2 ring-emerald-500/20' 
                    : 'bg-white text-slate-400 border-slate-200 hover:border-emerald-300 hover:text-emerald-600'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* Lista de Acordeones */}
          <div className="min-h-[300px]">
            {filteredFaqs.length > 0 ? (
              filteredFaqs.map(faq => (
                <FAQAccordion 
                  key={faq.id} 
                  faq={faq} 
                  isOpen={openId === faq.id}
                  onToggle={() => setOpenId(openId === faq.id ? null : faq.id)}
                />
              ))
            ) : (
              <div className="text-center py-20 bg-slate-50 rounded-3xl border-2 border-dashed border-slate-200">
                <p className="text-slate-400 font-bold italic text-sm">No se encontraron resultados para tu búsqueda.</p>
              </div>
            )}
          </div>

          {/* Pie de Bitácora */}
          <div className="mt-16 flex flex-col md:flex-row items-center justify-between border-t border-slate-50 pt-10 gap-6">
            <div className="flex items-center gap-4">
              {/* <div className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center text-white font-black text-xs">J</div>
              <div className="text-left">
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-800">SEMADET Jalisco</p>
                <p className="text-[9px] text-slate-400">Dirección General de Ordenamiento Territorial</p>
              </div> */}
            </div>
            <div className="flex gap-2">
              {/* <button className="px-6 py-3 bg-slate-50 text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-slate-100 transition-all border border-slate-200">
                Guía de Usuario
              </button>
              <button className="px-6 py-3 bg-emerald-600 text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-emerald-700 transition-all">
                Contacto Directo
              </button> */}
            </div>
          </div>
        </div>
      </section>
 <GemmaAssistant />
  

      {/* CSS personalizado para animaciones sin framer-motion */}
      <style>{`
        /* Definición de keyframes para efectos de entrada */
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleUpAndFade {
          0% { opacity: 0; transform: scale(0.9); }
          100% { opacity: 1; transform: scale(1); }
        }
        
        .animate-scale-up-and-fade {
            animation: scaleUpAndFade 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        }

        .animate-fade-in-up {
          animation: fadeInUp 1s ease-out forwards;
          opacity: 0;
        }

        .animate-fade-in-up-delay {
            animation: fadeInUp 1s ease-out 0.5s forwards;
            opacity: 0;
        }
      `}</style>
    </div>
  );
}